'use client'

import { useRef } from 'react'
import type { HeroSimpleFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import Eyebrow from '../ui/Eyebrow'
import Swoosh from '../svg/Swoosh'

export default function HeroSimple({ tag, title }: Readonly<HeroSimpleFragment>) {
	const ref = useRef<HTMLDivElement>(null)

	return (
		<section
			ref={ref}
			className="hero-simple relative bg-cover bg-center bg-blue mt-[--nav-height] overflow-hidden @container"
		>
			<div className="relative flex flex-col justify-center max-w-screen-2xl w-full mx-auto common-x-padding py-6 @5xl:py-20 min-h-[540px]">
				{tag ? <Eyebrow variant="secondary">{tag}</Eyebrow> : null}
				{title ? (
					<h1 className="heading-hero z-10 max-w-3xl @5xl:max-w-5xl text-white mt-2">
						<TextWithHighlight text={title} />
					</h1>
				) : null}

				<Swoosh className="absolute right-0 top-0 scale-[175%] translate-y-[35%] translate-x-1/2" />
			</div>
		</section>
	)
}
